import { createClass as _createClass, classCallCheck as _classCallCheck, typeof as _typeof } from '../_virtual/_rollupPluginBabelHelpers.js';
import { JsonApiDataDecorator } from './JsonApiDataDecorator.js';
import { JsonApiRecordDecorator } from './JsonApiRecordDecorator.js';

var JsonApiDecorator = /*#__PURE__*/function () {
  function JsonApiDecorator(store) {
    var _this = this;

    _classCallCheck(this, JsonApiDecorator);

    Object.keys(store).forEach(function (k) {
      if (store[k] && _typeof(store[k]) === 'object' && store[k].data && store[k].data[0]) {
        _this[k] = new JsonApiDataDecorator(store[k].data, _this);
      }
    });
  }

  return _createClass(JsonApiDecorator, [{
    key: "newObject",
    value: function newObject(type) {
      return Object.assign(new JsonApiRecordDecorator(), {
        type: type
      });
    }
  }]);
}();

export { JsonApiDecorator };